import { z } from 'zod';

export const InputSchema = z.object({
    accountId: z.number(),
});

export const SuccessResponseSchema = z.object({
    createdAt: z.string(),
    assignee: z.object({
        id: z.number(),
        type: z.string(),
        name: z.string(),
    }),
    // bets: z.array() etc..
});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export type TrpcResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'error';
          status: number;
          data: unknown;
      };
